export default __webpack_public_path__ + "static/media/dole-lemonade-bg-tablet@3x.7eae1ec3.png";